import type { SiteContent } from '../content/types';
import { HeroSection } from '../components/sections/hero-section';
import { TrustStrip } from '../components/sections/trust-strip';
import { IntroSection } from '../components/sections/intro-section';
import { ServicesGrid } from '../components/sections/services-grid';
import { BenefitsSection } from '../components/sections/benefits-section';
import { ProcessSection } from '../components/sections/process-section';
import { ReviewSlider } from '../components/sections/review-slider';
import { FaqPreviewSection } from '../components/sections/faq-preview-section';
import { ContactTeaserSection } from '../components/sections/contact-teaser-section';

interface HomePageProps {
  content: SiteContent;
}

export function HomePage({ content }: HomePageProps): JSX.Element {
  return (
    <>
      <HeroSection content={content} />
      <TrustStrip content={content} />
      <IntroSection content={content} />
      <ServicesGrid content={content} compact />
      <BenefitsSection content={content} />
      <ProcessSection content={content} />
      <ReviewSlider content={content} />
      <FaqPreviewSection content={content} />
      <ContactTeaserSection content={content} />
    </>
  );
}
